import { render, staticRenderFns } from "./ModaLocalProibidoItemBemPermanente.vue?vue&type=template&id=89bf2050&scoped=true"
import script from "./ModaLocalProibidoItemBemPermanente.vue?vue&type=script&lang=js"
export * from "./ModaLocalProibidoItemBemPermanente.vue?vue&type=script&lang=js"
import style0 from "./ModaLocalProibidoItemBemPermanente.vue?vue&type=style&index=0&id=89bf2050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bf2050",
  null
  
)

export default component.exports